import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { Button, Grid, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DeviceTypes } from '@iotv/iotv-v3-types';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { getGraphQueryRequestV2 } from '../../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
import { getDeviceEnabledTypes } from '../../../data/TypeHelpers';
import { LoadingAnimationModal } from '../../../Popup/Loading';
import { convertListToSelectorMinimum, SelectorGeneric } from '../../common/DeviceGenerics';
import { NavSections } from '../../navigation/NavSections';
import { PayloadParserContext } from '../PayloadParserContext';
import { getSourceEntities } from '../queries';
const getEntities = async (source, deviceType) => {
    if (source === undefined) {
        return [];
    }
    let res = await getGraphQueryRequestV2({
        contextObjects: [source],
        query: getSourceEntities(source, deviceType).query,
    });
    if (res.err === null && res.data !== null) {
        return res.data.getNodesOfType(deviceType);
    }
    return [];
};
const PayloadParserTarget = (props) => {
    const { setEntityType, setEntity, setSelectedDeviceType } = props;
    const { entity, entityType } = useContext(PayloadParserContext);
    const [{ contextCustomer, contextProperty }] = useContext(AppMainViewContext);
    const [entityOptions, setEntityOptions] = useState([]);
    const [entityChoice, setEntityChoice] = useState();
    const [entityList, setEntityList] = useState([]);
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [selectorDeviceType, setSelectorDeviceType] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const redirectNavigation = (entity) => {
        navigate(`/${NavSections.THINGSVIEW}/Group?supportedType=${entity}`);
    };
    useEffect(() => {
        const deviceEnabledTypeIds = getDeviceEnabledTypes();
        const options = convertListToSelectorMinimum(deviceEnabledTypeIds);
        setEntityOptions(options);
        if (options.length === 1) {
            setEntityType(options[0].name);
        }
    }, []);
    useEffect(() => {
        entityChoice && setEntityType(entityChoice.name);
    }, [entityChoice]);
    useEffect(() => {
        setEntity(undefined);
        if (entityType) {
            setLoading(true);
            getEntities(contextProperty ?? contextCustomer, entityType).then(dbEntities => {
                const dbEntityNamed = dbEntities.map(ent => {
                    return { ...ent, name: ent.name ?? ent.id };
                });
                setEntityList(dbEntityNamed);
                setLoading(false);
            });
        }
        else {
            setEntityList([]);
        }
    }, [entityType, contextCustomer, contextProperty]);
    useEffect(() => {
        if (entityChoice) {
            let options = deviceEnabledTypes[entityChoice.name];
            let headers = options.deviceTypes.map(dev => dev.deviceType);
            let formatted = headers.map(head => {
                return {
                    id: head.toLocaleString(),
                    name: DeviceTypes[head],
                };
            });
            setDeviceTypes(formatted);
            if (formatted.length === 1) {
                setSelectorDeviceType(formatted[0]);
            }
        }
        else {
            setDeviceTypes([]);
        }
    }, [entityChoice]);
    useEffect(() => {
        setSelectedDeviceType(selectorDeviceType ? parseInt(selectorDeviceType.id) : undefined);
    }, [selectorDeviceType]);
    return (_jsxs("div", { children: [loading && entityChoice && _jsx(LoadingAnimationModal, { message: `Retrieving ${entityChoice.name} Entities` }), _jsxs(Grid, { id: 'History-Selection', container: true, direction: 'row', size: { xs: 12 }, spacing: 1, sx: {
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }, children: [_jsx(Grid, { size: { xs: 3 }, children: _jsx(Typography, { variant: 'body2', component: 'p', color: 'primary', children: `2) Select Entity Type` }) }), _jsx(Grid, { size: { xs: 9 }, children: _jsx(SelectorGeneric, { disabled: entityOptions?.length === 0, description: 'Entity', choices: entityOptions, choice: entityChoice, choose: setEntityChoice }) }), _jsx(Grid, { size: { xs: 3 }, children: _jsx(Typography, { variant: 'body2', component: 'p', color: 'primary', children: `3) Select Entity` }) }), _jsx(Grid, { size: { xs: entityChoice ? 7 : 9 }, children: _jsx(SelectorGeneric, { none: true, disabled: entityChoice === undefined, description: `${entityChoice ? entityChoice.name : 'Entity'}`, choices: entityList, choice: entity, choose: setEntity }) }), entityChoice && (_jsx(Grid, { size: { xs: 2 }, onClick: () => redirectNavigation(entityChoice.name), children: _jsx(Button, { variant: 'outlined', children: `Create new ${entityChoice.name}` }) })), _jsx(Grid, { size: { xs: 3 }, children: _jsx(Typography, { variant: 'body2', component: 'p', color: 'primary', children: `4) Select Device Type` }) }), _jsx(Grid, { size: { xs: 9 }, children: _jsx(SelectorGeneric, { disabled: deviceTypes === undefined || deviceTypes.length < 2, description: 'Device Type', choices: deviceTypes, choice: selectorDeviceType, choose: setSelectorDeviceType }) })] })] }));
};
export default PayloadParserTarget;
